import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xxl-8",
  style: {"margin-top":"-30px"}
}
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7" }
const _hoisted_5 = { class: "symbol symbol-200px symbol-lg-150px symbol-fixed position-relative" }
const _hoisted_6 = { class: "flex-grow-1" }
const _hoisted_7 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "d-flex align-items-center mb-2" }
const _hoisted_10 = { class: "text-fprimary fs-2 fw-bolder me-1" }
const _hoisted_11 = { class: "d-flex flex-row align-items-center mb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "fw-bolder" }
const _hoisted_15 = { class: "d-flex flex-row align-items-center mb-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar2-week fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_17 = { class: "d-flex flex-column" }
const _hoisted_18 = { class: "fw-bolder" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 0,
  class: "d-flex flex-row align-items-center mb-4"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-workspace fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_22 = { class: "d-flex flex-column" }
const _hoisted_23 = { class: "fw-bolder" }
const _hoisted_24 = {
  key: 1,
  class: "d-flex flex-row align-items-center mb-4"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-text fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "d-flex flex-column gap-2 align-items-center" }
const _hoisted_28 = { class: "btn btn-info py-1 px-3" }
const _hoisted_29 = {
  key: 0,
  class: "fa fa-cog fa-spin fs-3"
}
const _hoisted_30 = {
  key: 1,
  class: "bi bi-cloud-arrow-down fs-3"
}
const _hoisted_31 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_32 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_33 = { class: "nav-item" }
const _hoisted_34 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = { class: "nav-item" }
const _hoisted_37 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_btnBack = _resolveComponent("btnBack")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_image, {
                class: "w-200px h-200px rounded",
                src: _ctx.evento?.logo,
                fit: 'cover'
              }, null, 8, ["src"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.evento.name), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.t("place")), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.evento?.place), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t("date")), 1),
                    _createElementVNode("span", {
                      innerHTML: _ctx.dateParticipate(_ctx.evento?.startdate, _ctx.evento?.enddate)
                    }, null, 8, _hoisted_19)
                  ])
                ]),
                (_ctx.evento?.modality)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.t("modality")), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.evento?.modality == 'V' ? 'Virtual' : 'Presencial'), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.evento?.note)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("p", {
                        innerHTML: _ctx.evento?.note,
                        class: "m-0"
                      }, null, 8, _hoisted_26)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_btnBack, {
                  to: `/${_ctx.company?.alias.toLowerCase()}/acreditation`,
                  class: "w-100"
                }, null, 8, ["to"]),
                _createVNode(_component_el_dropdown, null, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, {
                          command: "a",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'sumary-participation-event', { a: _ctx.evento.idevent, b: '', c: '' })))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Resumen del evento ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, {
                          command: "a",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.DownloadXLSXPDF('xlsx', 'reporte-participation-general', { a: _ctx.evento.idevent, b: '', c: '' })))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Reporte Inscripción ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, {
                          command: "a",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.DownloadXLSXPDF('xlsx', 'consolidated-participation', { a: _ctx.mbtoa(_ctx.evento.idevent) })))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Consolidado Nominal ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, {
                          command: "a",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.DownloadXLSXPDF('xlsx', 'reporte-itinerario', { a: _ctx.evento.idevent })))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Reporte Itinerario ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, {
                          command: "a",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.DownloadXLSXPDF('pdf', 'consolidated-institutions', { a: _ctx.evento.idevent, c: _ctx.idcheckdoc})))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Lista Instituciones ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_28, [
                      (_ctx.loader)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_29))
                        : (_openBlock(), _createElementBlock("i", _hoisted_30)),
                      _createTextVNode(" Descargar ")
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("ul", _hoisted_32, [
            _createElementVNode("li", _hoisted_33, [
              _createVNode(_component_router_link, {
                to: `/${_ctx.company?.alias.toLowerCase()}/acreditation/${_ctx.id}/manager/home`,
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('home')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            (_ctx.evento?.forms == 1)
              ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                  _createVNode(_component_router_link, {
                    class: "nav-link text-active-primary me-6",
                    to: `/${_ctx.company?.alias.toLowerCase()}/acreditation/${_ctx.id}/manager/forms`,
                    "active-class": "active"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('forms')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_35, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/${_ctx.company?.alias.toLowerCase()}/acreditation/${_ctx.id}/manager/sports`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('sports')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_36, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/${_ctx.company?.alias.toLowerCase()}/acreditation/${_ctx.id}/manager/clubs`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('institution')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_37, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/${_ctx.company?.alias.toLowerCase()}/acreditation/${_ctx.id}/manager/documents`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('documents')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loader]
    ]),
    _createVNode(_component_router_view)
  ], 64))
}